/* ==========================================================================
   IMAR · JavaScript (оригинален код) — тикер, пред/потоа, слајдер, видео,
   лепливо копче, датуми за достава, резултати, следење, кошничка, „нагоре“.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function define(name, cls) {
    if (!customElements.get(name)) customElements.define(name, cls);
  }

  function onVisible(el, cb, options) {
    if (!('IntersectionObserver' in window)) {
      cb();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.disconnect();
          cb();
        }
      });
    }, options || { rootMargin: '0px 0px -10% 0px' });
    io.observe(el);
  }

  /* ------------------------------------------------------------------
     Material Symbols: ако некоја икона не е вградена како SVG,
     се вчитува само таа икона од Google Fonts.
     ------------------------------------------------------------------ */
  var loadedIcons = {};
  function loadMissingIcons(root) {
    var nodes = (root || document).querySelectorAll('.imt-msym[data-icon]');
    if (!nodes.length) {
      document.documentElement.classList.add('imt-msym-ready');
      return;
    }
    var names = [];
    nodes.forEach(function (n) {
      var name = (n.getAttribute('data-icon') || '').trim().toLowerCase();
      if (/^[a-z0-9_]+$/.test(name) && !loadedIcons[name]) {
        loadedIcons[name] = true;
        names.push(name);
      }
    });
    if (!names.length) return;
    var all = Object.keys(loadedIcons).sort();
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0..1,0&icon_names=' +
      all.join(',') +
      '&display=block';
    link.onload = function () {
      if (document.fonts && document.fonts.load) {
        document.fonts.load('24px "Material Symbols Outlined"').then(function () {
          document.documentElement.classList.add('imt-msym-ready');
        });
      } else {
        document.documentElement.classList.add('imt-msym-ready');
      }
    };
    link.onerror = function () {
      document.documentElement.classList.add('imt-msym-ready');
    };
    document.head.appendChild(link);
  }

  /* ------------------------------------------------------------------
     Тикер
     ------------------------------------------------------------------ */
  class ImarTicker extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.imt-ticker__track');
      this.group = this.querySelector('.imt-ticker__group');
      if (!this.track || !this.group) return;
      this.build = this.build.bind(this);
      this.build();
      var self = this;
      if ('ResizeObserver' in window) {
        var w = this.offsetWidth;
        this.ro = new ResizeObserver(function () {
          if (Math.abs(self.offsetWidth - w) > 20) {
            w = self.offsetWidth;
            self.build();
          }
        });
        this.ro.observe(this);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.build);
    }
    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }
    build() {
      var track = this.track;
      var group = this.group;
      track.querySelectorAll('[data-clone]').forEach(function (c) {
        c.remove();
      });
      group.querySelectorAll('[data-fill]').forEach(function (c) {
        c.remove();
      });
      var items = Array.prototype.slice.call(group.children);
      if (!items.length) return;
      var viewport = this.offsetWidth || window.innerWidth;
      var guard = 0;
      while (group.scrollWidth < viewport && guard < 30) {
        items.forEach(function (it) {
          var c = it.cloneNode(true);
          c.setAttribute('data-fill', '');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          group.appendChild(c);
        });
        guard++;
      }
      var clone = group.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) {
        n.removeAttribute('data-shopify-editor-block');
      });
      track.appendChild(clone);
      var speed = parseFloat(this.getAttribute('data-speed')) || 3;
      var pxPerSecond = 22 + speed * 14;
      var duration = Math.max(4, group.scrollWidth / pxPerSecond);
      this.style.setProperty('--tk-duration', duration.toFixed(2) + 's');
      this.classList.toggle('imt-ticker--reverse', this.getAttribute('data-direction') === 'reverse');
      this.classList.add('is-ready');
    }
  }
  define('imt-ticker', ImarTicker);

  /* ------------------------------------------------------------------
     Пред / Потоа
     ------------------------------------------------------------------ */
  class ImarBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.imt-ba__range');
      var self = this;
      this.set = function (pct) {
        pct = Math.max(0, Math.min(100, pct));
        self.style.setProperty('--ba-pos', pct + '%');
        if (self.range) self.range.value = pct;
      };
      if (this.range) {
        this.range.addEventListener('input', function () {
          self.set(parseFloat(self.range.value));
        });
      }
      var dragging = false;
      function pos(e) {
        var r = self.getBoundingClientRect();
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        return ((x - r.left) / r.width) * 100;
      }
      this.addEventListener('pointerdown', function (e) {
        dragging = true;
        self.classList.add('is-dragging');
        self.set(pos(e));
        if (self.setPointerCapture && e.pointerType !== 'touch') self.setPointerCapture(e.pointerId);
      });
      this.addEventListener('pointermove', function (e) {
        if (dragging) self.set(pos(e));
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        self.addEventListener(ev, function () {
          dragging = false;
          self.classList.remove('is-dragging');
        });
      });
    }
  }
  define('imt-before-after', ImarBeforeAfter);

  /* ------------------------------------------------------------------
     Видео (автоматско пуштање кога е видливо)
     ------------------------------------------------------------------ */
  class ImarVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      var self = this;
      var v = this.video;
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      this.autoplay = this.getAttribute('data-autoplay') === 'true';
      if (this.autoplay) {
        v.muted = true;
        v.setAttribute('muted', '');
      }
      this.userPaused = false;
      this.btn = this.querySelector('.imt-video__btn');
      this.sound = this.querySelector('.imt-video__sound');
      if (this.btn) {
        this.btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.toggle();
        });
      }
      if (this.sound) {
        this.sound.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          v.muted = !v.muted;
          self.classList.toggle('is-unmuted', !v.muted);
        });
      }
      v.addEventListener('click', function () {
        self.toggle();
      });
      v.addEventListener('play', function () {
        self.classList.add('is-playing');
      });
      v.addEventListener('pause', function () {
        self.classList.remove('is-playing');
      });
      if (this.autoplay && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (!self.userPaused) self.play();
              } else if (!v.paused) {
                v.pause();
              }
            });
          },
          { threshold: 0.25 }
        );
        this.io.observe(this);
      } else if (this.autoplay) {
        this.play();
      }
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
    play() {
      var p = this.video.play();
      if (p && p.catch) p.catch(function () {});
    }
    toggle() {
      if (this.video.paused) {
        this.userPaused = false;
        this.play();
      } else {
        this.userPaused = true;
        this.video.pause();
      }
    }
  }
  define('imt-video', ImarVideo);

  /* ------------------------------------------------------------------
     Слајдер (scroll-snap) со стрелки и точки
     ------------------------------------------------------------------ */
  class ImarCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.imt-carousel__viewport');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.imt-carousel__slide'));
      this.prev = this.querySelector('.imt-carousel__arrow--prev');
      this.next = this.querySelector('.imt-carousel__arrow--next');
      this.dotsWrap = this.querySelector('.imt-carousel__dots');
      if (!this.viewport || !this.slides.length) return;
      var self = this;
      this.update = this.update.bind(this);
      if (this.prev)
        this.prev.addEventListener('click', function () {
          self.go(self.index() - self.perView());
        });
      if (this.next)
        this.next.addEventListener('click', function () {
          self.go(self.index() + self.perView());
        });
      var t;
      this.viewport.addEventListener(
        'scroll',
        function () {
          clearTimeout(t);
          t = setTimeout(self.update, 60);
        },
        { passive: true }
      );
      window.addEventListener('resize', function () {
        self.buildDots();
        self.update();
      });
      this.buildDots();
      this.update();
      if (this.getAttribute('data-autoplay') === 'true' && !reduceMotion) {
        var speed = (parseFloat(this.getAttribute('data-autoplay-speed')) || 5) * 1000;
        this.timer = setInterval(function () {
          if (self.matches(':hover')) return;
          var nextIndex = self.index() + 1;
          if (nextIndex > self.slides.length - self.perView()) nextIndex = 0;
          self.go(nextIndex);
        }, speed);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    perView() {
      var v = parseFloat(getComputedStyle(this).getPropertyValue('--cs-per-view')) || 1;
      return Math.max(1, Math.round(v));
    }
    index() {
      var left = this.viewport.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      var base = this.slides[0].offsetLeft;
      this.slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - base - left);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    }
    go(i) {
      var max = Math.max(0, this.slides.length - this.perView());
      i = Math.max(0, Math.min(max, i));
      var base = this.slides[0].offsetLeft;
      this.viewport.scrollTo({ left: this.slides[i].offsetLeft - base, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    pages() {
      return Math.max(1, this.slides.length - this.perView() + 1);
    }
    buildDots() {
      if (!this.dotsWrap) return;
      var pages = this.pages();
      this.dotsWrap.innerHTML = '';
      var self = this;
      if (pages <= 1) {
        this.dotsWrap.hidden = true;
        return;
      }
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'imt-carousel__dot';
        b.setAttribute('aria-label', String(i + 1));
        (function (n) {
          b.addEventListener('click', function () {
            self.go(n);
          });
        })(i);
        this.dotsWrap.appendChild(b);
      }
      this.dotsWrap.hidden = false;
    }
    update() {
      var i = this.index();
      var overflow = this.viewport.scrollWidth > this.viewport.clientWidth + 4;
      if (this.prev) {
        this.prev.hidden = !overflow;
        this.prev.disabled = i <= 0;
      }
      if (this.next) {
        this.next.hidden = !overflow;
        this.next.disabled = i >= this.slides.length - this.perView();
      }
      if (this.dotsWrap) {
        Array.prototype.forEach.call(this.dotsWrap.children, function (d, n) {
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      }
    }
  }
  define('imt-carousel', ImarCarousel);

  /* ------------------------------------------------------------------
     Лепливо копче „Во кошничка“
     ------------------------------------------------------------------ */
  class ImarStickyAtc extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.sectionId = this.getAttribute('data-section');
      this.idInput = this.querySelector('[data-satc-id]');
      this.select = this.querySelector('[data-satc-select]');
      this.priceEl = this.querySelector('[data-satc-price]');
      this.btn = this.querySelector('.imt-satc__btn');
      this.label = this.querySelector('[data-satc-label]');
      this.img = this.querySelector('.imt-satc__img img');

      if (this.getAttribute('data-function') === 'scroll') {
        this.btn &&
          this.btn.addEventListener(
            'click',
            function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              self.scrollToBuy();
            },
            true
          );
      }

      if (this.select) {
        this.select.addEventListener('change', function () {
          self.applyOption(self.select.selectedOptions[0]);
        });
      }

      if (this.getAttribute('data-display') !== 'always') this.watch();
      else this.setOpen(true);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (!event || !event.data || event.data.sectionId !== self.sectionId) return;
          self.syncVariant(event.data.variant);
        });
      }
    }
    disconnectedCallback() {
      if (this.unsub) this.unsub();
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      document.body.classList.remove('imt-satc-open');
    }
    target() {
      var info = document.getElementById('ProductInfo-' + this.sectionId);
      if (!info) return null;
      return (
        info.querySelector('.product-form__buttons') ||
        info.querySelector('[id*="easysell"], [class*="easysell"], [class*="es-form"]') ||
        info.querySelector('product-form') ||
        info.querySelector('.price') ||
        info
      );
    }
    watch() {
      var self = this;
      var t = this.target();
      if (!t) {
        this.setOpen(true);
        return;
      }
      var ticking = false;
      function check() {
        ticking = false;
        var r = t.getBoundingClientRect();
        self.setOpen(r.bottom < 0);
      }
      this.onScroll = function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(check);
        }
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      check();
    }
    setOpen(open) {
      if (this._open === open) return;
      this._open = open;
      this.classList.toggle('is-visible', open);
      document.body.classList.toggle('imt-satc-open', open);
      if (open) document.body.style.setProperty('--imt-satc-h', this.offsetHeight + 'px');
    }
    scrollToBuy() {
      var t = this.target();
      if (t) t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
    applyOption(opt) {
      if (!opt) return;
      if (this.idInput) this.idInput.value = opt.value;
      var price = opt.getAttribute('data-price');
      var compare = opt.getAttribute('data-compare');
      var now = this.priceEl && this.priceEl.querySelector('.imt-satc__now');
      var was = this.priceEl && this.priceEl.querySelector('.imt-satc__was');
      if (now && price) now.innerHTML = price;
      if (was) {
        was.innerHTML = compare || '';
        was.hidden = !compare;
      }
      var badge = this.priceEl && this.priceEl.querySelector('.imt-satc__badge');
      if (badge) badge.hidden = !compare;
      var btnPrice = this.querySelector('[data-satc-btn-price]');
      if (btnPrice && price) btnPrice.innerHTML = '· ' + price;
      var img = opt.getAttribute('data-img');
      if (img && this.img) {
        this.img.removeAttribute('srcset');
        this.img.src = img;
      }
      var available = !opt.disabled;
      if (this.btn) this.btn.disabled = !available;
      if (this.label)
        this.label.textContent = available ? this.getAttribute('data-label') : this.getAttribute('data-sold-out');
    }
    syncVariant(variant) {
      if (!variant) return;
      if (this.select) {
        var opt = this.select.querySelector('option[value="' + variant.id + '"]');
        if (opt) {
          this.select.value = String(variant.id);
          this.applyOption(opt);
          return;
        }
      }
      if (this.idInput) this.idInput.value = variant.id;
      if (this.btn) this.btn.disabled = !variant.available;
      if (this.label)
        this.label.textContent = variant.available ? this.getAttribute('data-label') : this.getAttribute('data-sold-out');
    }
  }
  define('imt-sticky-atc', ImarStickyAtc);

  /* ------------------------------------------------------------------
     Тек на достава — датуми
     ------------------------------------------------------------------ */
  class ImarCheckpoints extends HTMLElement {
    connectedCallback() {
      var fmt = this.getAttribute('data-format') || 'mm_dd';
      var days = (this.getAttribute('data-days') || 'Mon, Tue, Wed, Thu, Fri, Sat, Sun').split(',').map(function (s) {
        return s.trim();
      });
      var months = (this.getAttribute('data-months') || 'Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec')
        .split(',')
        .map(function (s) {
          return s.trim();
        });
      function format(d) {
        var dayName = days[(d.getDay() + 6) % 7] || '';
        var month = months[d.getMonth()] || '';
        var dd = d.getDate();
        var mm = d.getMonth() + 1;
        switch (fmt) {
          case 'dd_mm':
            return dd + ' ' + month;
          case 'day_dd_mm':
            return dayName + ', ' + dd + ' ' + month;
          case 'day_mm_dd':
            return dayName + ', ' + month + ' ' + dd;
          case 'numeric':
            return (dd < 10 ? '0' : '') + dd + '.' + (mm < 10 ? '0' : '') + mm + '.';
          default:
            return month + ' ' + dd;
        }
      }
      function add(n) {
        var d = new Date();
        d.setDate(d.getDate() + (parseInt(n, 10) || 0));
        return d;
      }
      this.querySelectorAll('[data-template]').forEach(function (el) {
        var tpl = el.getAttribute('data-template') || '';
        var start = format(add(el.getAttribute('data-min')));
        var end = format(add(el.getAttribute('data-max')));
        el.innerHTML = tpl.split('[start_date]').join(start).split('[end_date]').join(end);
      });
    }
  }
  define('imt-checkpoints', ImarCheckpoints);

  /* ------------------------------------------------------------------
     Резултати — бројач + ленти
     ------------------------------------------------------------------ */
  class ImarCount extends HTMLElement {
    connectedCallback() {
      var self = this;
      var to = parseInt(this.getAttribute('data-to'), 10) || 0;
      var row = this.closest('.imt-results__row');
      if (reduceMotion) {
        if (row) row.classList.add('is-in');
        return;
      }
      this.textContent = '0%';
      onVisible(this, function () {
        if (row) row.classList.add('is-in');
        var t0 = null;
        var dur = 1200;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          self.textContent = Math.round(to * eased) + '%';
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }
  }
  define('imt-count', ImarCount);

  /* ------------------------------------------------------------------
     Следење на пратка (17TRACK)
     ------------------------------------------------------------------ */
  class ImarTrack extends HTMLElement {
    connectedCallback() {
      var self = this;
      var form = this.querySelector('form');
      var input = this.querySelector('input[name="tracking_number"]');
      var err = this.querySelector('.imt-track__error');
      if (!form || !input) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var num = input.value.trim();
        if (!num) {
          if (err) err.hidden = false;
          input.focus();
          return;
        }
        if (err) err.hidden = true;
        self.load(function () {
          if (window.YQV5 && window.YQV5.trackSingle) {
            window.YQV5.trackSingle({
              YQ_ContainerId: self.getAttribute('data-container'),
              YQ_Height: 560,
              YQ_Fc: '0',
              YQ_Lang: (document.documentElement.lang || 'en').slice(0, 2),
              YQ_Num: num,
            });
          } else {
            window.open('https://t.17track.net/#nums=' + encodeURIComponent(num), '_blank', 'noopener');
          }
        });
      });
    }
    load(cb) {
      if (window.YQV5) return cb();
      var s = document.createElement('script');
      s.src = 'https://www.17track.net/externalcall.js';
      s.async = true;
      s.onload = cb;
      s.onerror = cb;
      document.head.appendChild(s);
    }
  }
  define('imt-track', ImarTrack);

  /* ------------------------------------------------------------------
     Кошничка: „Додади“ за препорачани производи
     ------------------------------------------------------------------ */
  class ImarCartAdd extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.btn = this.querySelector('button');
      if (!this.btn) return;
      this.btn.addEventListener('click', function () {
        self.add();
      });
    }
    add() {
      var self = this;
      var drawer = document.querySelector('cart-drawer');
      var spinner = this.querySelector('.loading__spinner');
      this.btn.setAttribute('aria-disabled', 'true');
      this.btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(self.getAttribute('data-variant-id'), 10), quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (res && res.status) throw new Error(res.description || res.message);
          if (drawer && drawer.renderContents && res.sections) {
            drawer.renderContents(res);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'imt-cart-add', cartData: res });
          }
        })
        .catch(function (e) {
          console.error(e);
          self.btn.removeAttribute('aria-disabled');
          self.btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }
  }
  define('imt-cart-add', ImarCartAdd);

  /* ------------------------------------------------------------------
     Кошничка: лента со цели во друга валута (пр. imaralb.com)
     Целите се внесени во основната валута (ден) → се претвораат со
     курсот на Shopify (Shopify.currency.rate) за пазарот на купувачот.
     ------------------------------------------------------------------ */
  class ImarCprog extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('imt-cprog--convert')) return;
      try {
        this.convert();
      } catch (e) {
        console.error(e);
      }
      this.classList.remove('imt-cprog--convert');
    }
    convert() {
      var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      if (!rate || Math.abs(rate - 1) < 1e-9) return;
      var total = parseInt(this.getAttribute('data-total'), 10) || 0;
      var goals = JSON.parse(this.getAttribute('data-goals') || '[]');
      if (!goals.length) return;
      var max = 0;
      goals.forEach(function (g) {
        g.c = Math.round(g.a * rate) * 100;
        if (g.c > max) max = g.c;
      });
      if (!max) return;
      var next = null;
      goals.forEach(function (g) {
        if (g.c > total && (!next || g.c < next.c)) next = g;
      });
      var self = this;
      goals.forEach(function (g) {
        var el = self.querySelector('.imt-cprog__goal[data-i="' + g.i + '"]');
        if (el) el.classList.toggle('is-reached', total >= g.c);
      });
      this.style.setProperty('--cp-fill', Math.min(100, (total * 100) / max).toFixed(2) + '%');
      var msgEl = this.querySelector('.imt-cprog__msg');
      if (!msgEl) return;
      if (next) {
        var cur = this.getAttribute('data-cur') || '';
        var amount = String(Math.ceil((next.c - total) / 100)) + (cur ? ' ' + cur : '');
        msgEl.innerHTML = (this.getAttribute('data-msg') || '')
          .split('[amount]').join(amount)
          .split('[next_goal]').join(next.t || '');
      } else {
        msgEl.innerHTML = this.getAttribute('data-success') || '';
      }
    }
  }
  define('imt-cprog', ImarCprog);

  /* ------------------------------------------------------------------
     Галерија на производ: точки на мобилен
     ------------------------------------------------------------------ */
  function initGalleryDots(root) {
    (root || document).querySelectorAll('.imt-gallery-dots slider-component[id^="GalleryViewer"]').forEach(function (sc) {
      if (sc.querySelector('.imt-dots')) return;
      var list = sc.querySelector('.product__media-list');
      if (!list) return;
      function items() {
        return Array.prototype.filter.call(list.querySelectorAll('.product__media-item'), function (li) {
          return li.offsetParent !== null || li.clientWidth > 0;
        });
      }
      var count = items().length;
      if (count < 2) return;
      var wrap = document.createElement('div');
      wrap.className = 'imt-dots';
      for (var i = 0; i < count; i++) {
        (function (n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'imt-dots__dot';
          b.setAttribute('aria-label', String(n + 1) + ' / ' + count);
          b.addEventListener('click', function () {
            var cur = items();
            if (!cur[n]) return;
            list.scrollTo({ left: cur[n].offsetLeft - cur[0].offsetLeft, behavior: 'smooth' });
          });
          wrap.appendChild(b);
        })(i);
      }
      sc.appendChild(wrap);
      function update() {
        var cur = items();
        if (!cur.length) return;
        var left = list.scrollLeft;
        var best = 0;
        var bestD = Infinity;
        cur.forEach(function (li, i) {
          var d = Math.abs(li.offsetLeft - cur[0].offsetLeft - left);
          if (d < bestD) {
            bestD = d;
            best = i;
          }
        });
        Array.prototype.forEach.call(wrap.children, function (d, i) {
          d.setAttribute('aria-current', i === best ? 'true' : 'false');
        });
      }
      var t;
      list.addEventListener(
        'scroll',
        function () {
          clearTimeout(t);
          t = setTimeout(update, 50);
        },
        { passive: true }
      );
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          setTimeout(update, 120);
        });
      }
      update();
    });
  }

  /* ------------------------------------------------------------------
     Копче „нагоре“
     ------------------------------------------------------------------ */
  function initScrollTop() {
    var btn = document.querySelector('[data-imt-scroll-top]');
    if (!btn) return;
    var offset = parseInt(btn.getAttribute('data-offset'), 10) || 400;
    var ticking = false;
    function check() {
      btn.classList.toggle('is-visible', window.scrollY > offset);
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(check);
        }
      },
      { passive: true }
    );
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    check();
  }

  function init(root) {
    loadMissingIcons(root);
    initGalleryDots(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initScrollTop();
    });
  } else {
    init();
    initScrollTop();
  }
  window.addEventListener('load', function () {
    initGalleryDots();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(function () {
        initGalleryDots();
        loadMissingIcons();
      }, 200);
    });
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          loadMissingIcons();
          break;
        }
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    });
  }
})();
